// extracted by mini-css-extract-plugin
module.exports = {"containerLoader":"Loader_containerLoader__1eOy8","loader":"Loader_loader__1dwBj","rotation":"Loader_rotation__2qGwL"};